<template>
<div class="dashboard">
  <div class="header">داشبورد</div>
  <div class="top-row">
    <div class="right-section">
      <div class="right-section-top-row"><referral/></div>
      <div class="right-section-bottom-row">
        <div class="step-auth"><step-auth/></div>
        <div class="total-value"><total-value/></div>
      </div>
    </div>
    <div class="left-section"><level-chart/></div>
  </div>

  <div class="bottom-row">
    <open-order-table/>
  </div>
  <div class="history-link" @click="$router.push('/panel/history')">
    مشاهده همه تاریخچه
    <img src="../../../assets/icon/left-arrow.svg"/>
  </div>
</div>
</template>

<script>
import Referral from "./dashborad/referral";
import StepAuth from "./dashborad/step-auth";
import TotalValue from "./dashborad/total-value";
import LevelChart from "./dashborad/level-chart";
import OpenOrderTable from "./dashborad/open-order-table";
import io from "socket.io-client";
import state from "@/lib/state";
export default {
  name: "dashboard",
  components: {OpenOrderTable, LevelChart, TotalValue, StepAuth, Referral},

}
</script>

<style lang="scss" scoped>
.history-link{
  display: flex;
  align-items: center;
  column-gap: 8px;
  color: #1199FA;
  cursor: pointer;
  font-size: clamp(14px,1.5vw,16px);
  text-align: left;
  justify-content: flex-end;
}
.panel-box{
  background: linear-gradient(180deg, #091222 0%, #0A1425 100%);
  box-shadow: 0 4px 24px -1px rgba(0, 0, 0, 0.25);
  backdrop-filter: blur(40px);
  border-radius: 20px;
  padding: 35px;
}

.dashboard{
  display: flex;
  flex-direction: column;
  gap: 24px;

  .header{
    display: flex;
    justify-content:flex-start;
    font-size: clamp(14px , 2vw ,22px);
    color: #FBFBFD;
    margin: 30px 0;
    padding: 0 35px;
  }

  .top-row{
    display: flex;
    flex-direction: row;
    gap: 24px;
    flex-wrap: wrap;

    .left-section{
      flex-grow: 1;
      flex-basis: 100px;
      @extend .panel-box;
    }

    .right-section{
      display: flex;
      flex-direction: column;
      gap: 24px;
      flex-grow: 5;
      flex-basis: 500px;

      .right-section-top-row{
        flex-grow: 1;
        @extend .panel-box;
      }

      .right-section-bottom-row{
        display: flex;
        flex-direction: row;
        gap: 24px;
        flex-wrap: wrap;

        .step-auth{
          flex-grow: 2;
          flex-basis: 0;
          padding: 24px !important;
          @extend .panel-box;
        }

        .total-value{
          flex-grow: 1;
          flex-basis: 0;
          padding: 17px !important;
          @extend .panel-box;
        }
      }

    }
  }

  .bottom-row{
    flex-grow: 1;
    @extend .panel-box
  }
}
</style>